import NCard from "../../../../../../../../components/simple/Containers/NCard/NCard";
import {actTemplatesEditPageIds} from "../../../../../../../../tests/testIds";
import text from "../../../../../../../../services/localization/text";
import ActTemplatesFormGroup from "../ActTemplateFormGroup";
import QuestionTooltip from "../../../../../../../../components/simple/Containers/QuestionTooltip/QuestionTooltip";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import api from "../../../../../../../../services/apiInstance/api";
import actTemplatesEditActions
  from "../../../../../../../../store/organization/item/actTemplatesEdit/actTemplatesEditActions";
import {onGetActTemplateProp} from "../../../../../../../../services/flowTypes/propFnFlowTypes";
import BtnDel from "../../../../../../../../components/simple/Buttons/BtnDel/BtnDel";

const ScheduledGeneration = ({
                               onClear,
                               hasValues
                             }: {
  onClear: Function,
  onGetActTemplateProp: onGetActTemplateProp,
  hasValues: boolean
}) => {
  const [userIdOptions, setUserIdOptions] = useState([]);

  useEffect(() => {
    api
      .listUsersForScheduledReports()
      .then(({data}) => {
        setUserIdOptions(
          data.map((item) => {
            return {value: item.id, label: item.name};
          })
        );
      });
  }, []);

  return (
    <NCard addClasses={"mb_3du mt_1du flex_jc-sb ai_fe"}>
      <div className="flex pos_rel">
        <ActTemplatesFormGroup
          required={hasValues}
          formFieldType={"switcher"}
          propName={"scheduledPeriod"}
          label={text.reportGenerationPeriod}
          labelTooltip={
            <QuestionTooltip isHighZIndex={true} isRightPositioned={true}>
              {text.actTemplatesView.period}
            </QuestionTooltip>
          }
          options={[
            {value: "MONTHLY", label: text.MONTHLY},
            {value: "QUARTERLY", label: text.QUARTERLY},
            {value: "ANNUAL", label: text.ANNUAL},
          ]}
          key={"period"}
          addClasses={"horizontal_space_item"}
          selectInputId={actTemplatesEditPageIds.periodSelect}
          idForTest={actTemplatesEditPageIds.period}
        />
        <ActTemplatesFormGroup
          required={hasValues}
          formFieldType={"input-number"}
          propName={"scheduledDay"}
          labelTooltip={
            <QuestionTooltip isHighZIndex={true} isRightPositioned={true}>
              {text.actTemplatesView.dayOfMonthHelpText}
            </QuestionTooltip>
          }
          label={text.dayOfMonth}
          addClasses={"horizontal_space_item"}
          idForTest={actTemplatesEditPageIds.inputActTemplateName}
        />
        <ActTemplatesFormGroup
          required={hasValues}
          propName={"scheduleInitiatorId"}
          formFieldType={"select"}
          label={text.initiator}
          placeholder={text.initiator}
          addClasses={"w_half-card horizontal_space_item z_1100"}
          options={userIdOptions}
          selectInputId={actTemplatesEditPageIds.initiatorSelect}
          idForTest={actTemplatesEditPageIds.initiator}
          isSearchable={true}
          noOptionsMessage={text.initiatorSelect.userId}
          key={"scheduleInitiatorId"}
        />
      </div>
      {hasValues && <BtnDel

        onClick={onClear}
        id={actTemplatesEditPageIds.clearButton}
      >
        {text.clearAll}
      </BtnDel>}
    </NCard>
  );
};


const mapDispatchToProps = dispatch => {
  return {
    onGetActTemplateProp: (prop, data) => dispatch({
      type: actTemplatesEditActions.ACT_TEMPLATES_PROP_SET, value: {
        prop: prop,
        data: data
      }
    }),
    onClear: () => dispatch({type: actTemplatesEditActions.ACT_TEMPLATES_SCHEDULED_CONFIG_CLEAR}),
  };
};

const mapStateToProps = state => {
  return {
    hasValues: !!state.organization.item.actTemplatesEdit['scheduledDay'] ||
      !!state.organization.item.actTemplatesEdit['scheduledPeriod'] ||
      !!state.organization.item.actTemplatesEdit['scheduleInitiatorId']
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledGeneration);
